import {getTrackingUrl,getCourier} from 'tracking-number-validation';

export function formatPhoneNumber(s) {
    let s2 = (""+s).replace(/\D/g, ''),
        m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
}

export function formatDate(time=''){
    let date = new Date();
    date.setTime(parseInt(`${time}`.split('-')[0]) - 14400000); // Hard coding a 4 hour offset based on current server date handling
    return date.toLocaleString('en-US',{timeZone:'utc'});
}

export function zeroPad(number,digits){
    return ((new Array(digits)).join('0') + number).slice(-digits);
}

export function format({type,data,zero,append = ''}){
    if(zero && data.toString() === '0'){
        return zero;
    }
    return ((({
        string(str){
            return str;
        },
        date(str){
            return formatDate(str);
        },
        date_short(str){
            return formatDate(str).split(',')[0];
        },
        phone(str){
            return formatPhoneNumber(str);
        },
        bool(val){
            return val ? `<i class="icon-checked"></i>` : `<i class="icon-unchecked"></i>`;
        },
        cur(str){
            return "$" + parseFloat(str).toFixed(2);
        },
        dec(str){
            return parseFloat(str).toString();
        },
        track(str){
            let url = str && getCourier(str).length > 0 ? getTrackingUrl(str) : false;
            return url ? `<a href="${url}" target="_blank">${str}</a>` : str || '';
        }
    })[type] || (str => str))(data)) + ' ' + append;
}